/* eslint-env browser */

import * as React from 'react'

require('../../container/client')

const ReactDOM = require('react-dom')
const ResetPasswordForm = require('./components/ResetPasswordForm')
const ResetPasswordWithTokenForm = require('./components/ResetPasswordWithTokenForm')
const DomHelper = require('../../client/clientjs/dom-helper')

DomHelper.onDocumentReady(() => {
  const renderElt = DomHelper.query('#react-render-reset-password-form')
  if (window.initialState.resetToken) {
    ReactDOM.render(
      <ResetPasswordWithTokenForm appConfig={window.initialState} resetToken={window.initialState.resetToken} />,
      renderElt
    )
  } else {
    ReactDOM.render(<ResetPasswordForm appConfig={window.initialState} />, renderElt)
  }
})
